"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StrengthBar;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _styled = require("./styled");

function StrengthBar(props) {
  var passwordState = props.passwordState,
      passwordStateLabels = props.passwordStateLabels;
  var label = (0, _react.useMemo)(function () {
    return passwordStateLabels ? passwordStateLabels[passwordState] : undefined;
  }, [passwordState, passwordStateLabels]);
  return _react["default"].createElement(_styled.StyledStrenghtBar, null, _react["default"].createElement(_styled.StyledStateBar, {
    passwordState: passwordState
  }), _react["default"].createElement(_RenderIf["default"], {
    isTrue: label
  }, _react["default"].createElement(_styled.StyledStateLabel, {
    passwordState: passwordState
  }, label)));
}

StrengthBar.propTypes = {
  /**
   * The state of the password strenght
   */
  passwordState: _propTypes["default"].oneOf(['weak', 'average', 'strong']),

  /**
   * The label to show at the right of the bar
   */
  passwordStateLabels: _propTypes["default"].shape({
    weak: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    average: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    strong: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
  })
};
StrengthBar.defaultProps = {
  passwordState: undefined,
  passwordStateLabels: undefined
};